import { differenceInSeconds, isValid, parseISO } from 'date-fns';

/**
 *
 * @param {string} [dateTime] - The date and time in UTC, ISO 8601 format (e.g., '2024-08-20T09:56:59.287Z')
 *
 * @returns {number} time difference in seconds
 */
export const getTimeDifferenceInSeconds = (dateTime: string): number => {
  const parsedDate = parseISO(dateTime);

  if (!isValid(parsedDate)) {
    return Number.NaN;
  }

  const now = new Date();
  return differenceInSeconds(parsedDate, now);
};
